// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import {Link} from 'react-router-dom';
  import { withRouter } from 'react-router';
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog';

  
  
  class UnblockingCourts extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      console.log('UnblockingCourts..')
      console.log(props)
      this.state = {
        bulkbooking_id: props.match.params.id,
        data_uploaded: false,
        data_error: false,
        mobile_no: '',
        court_name: '',
        start_date: '',
        start_time: '',
        results: {
          court: '',
          start_time: '',
          date: '',
        },
        court_bookings: [],
        loading:false,
        dialog_open_failed_list:false,
        failed_list:[],
      };
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
  
    componentDidMount() {
        console.log('book')
      // this.getDetails(this.state.subscription_id)
    }
  
    postCancelBooking(data, props) {
      console.log('bulkbooking_id')
      console.log(this.state.bulkbooking_id)
      console.log(data);
      this.setState({loading:true})
      const url = `${getLocationOrigin()}/court_booking/unblock_court/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'bulkbooking_id': this.state.bulkbooking_id,
                                          'source':'bulkbooking_page'
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                  
          // alert(response.message);
          this.setState({loading:false,failed_list:response.failed_slots,dialog_open_failed_list:true})
          })
        .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({loading:false})
        });
    }
    
    getDetails(data){
        console.log('get details')
        const url = `${getLocationOrigin()}/court_booking/get_bulk_booking/?subscription_id=${data}`;
        const options = {...defaultOptions};

        console.log('Going to fetch')
        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({ court_bookings: data.court_bookings}))
        .catch(error => error);
    }

    handleSubmit(event) {
      event.preventDefault();
      console.log('Submit');
      this.postCancelBooking(this.state.subscription_id, this.props);
      console.log('post');
      console.log(this.state);
    }

    handleOpen = () => {
      this.setState({dialog_open_failed_list:true});
    };

    handleClose = () => {
      this.setState({dialog_open_failed_list:false});
    };
  
    render() {
      console.log('render')
      console.log(this.state.results)
      console.log(this.state.failed_list)
      const okaction = [
      <FlatButton
        label="OK"
        primary={true}
        onClick={this.handleClose}
      />
      ];

      return(
        <div style={styles.container}>
          <div className="row col-md-8 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}>Cancel Court Blocking</h3>
            </div>
            <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            {this.state.loading === true ?
              <div style={{height:100}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>
              </div>
            :
            <div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-12">
                <div style={{textAlign:'center'}}>Are you sure you want to cancel booking??</div>
              </div>
              </div>
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Cancel Booking" style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
            </div>
            }
            </form>
          </div>

          <div>
              <Dialog
                    actions={okaction}
                    modal={false}
                    open={this.state.dialog_open_failed_list}
                    onRequestClose={this.handleClose}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                  >
              <div>
              {this.state.failed_list.length > 0 ?
                <div style={styles.main_header} className="col-md-12">
                <h4 style={{textAlign:'center'}}> Failed To Cancel </h4>
                  {this.state.failed_list.map((list,index) =>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <div className="col-md-4">
                        {list.name}
                      </div>
                      <div className="col-md-4">
                        {list.date}
                      </div>
                      <div className="col-md-4">
                        {list.time}
                      </div>
                    </div>
                      ) 
                  }
                </div>  
                  :
                <h4 style={{textAlign:'center'}}>Cancelled Successfully</h4>
              }
               </div> 
               </Dialog>
            </div>
        </div>
      );
    }
  }
  
  export default UnblockingCourts;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/unblockingCourts/index.js